import { CmtsAdminIdentityPage } from "../components/admin/index.js";
import { cmtsPermissionsAdminIdentityConfig } from "../config/adminIdentity.config.js";

export function CmtsPermissionsPage() {
  return <CmtsAdminIdentityPage config={cmtsPermissionsAdminIdentityConfig} />;
}

export default CmtsPermissionsPage;
